import { STORAGE_KEYS } from "../storage.keys.jsx";
import { storageService } from "../storage.service.jsx";

const keys = {
    mealsData: "mealsData",
    selectedMealId: "selectedMealId",
    selectedDate: "selectedDate",
    selectedDetailItem: "selectedDetailItem",
    selectedDetailType: "selectedDetailType",
    activeTab: "activeTab",
    selectedKitchenId: "selectedKitchenId",
    scannedKitchenId: "scannedKitchenId",
};

export const kitchenStorage = {
    getMealsData: () => {
        const data = storageService.get(STORAGE_KEYS.KITCHEN_MEALS_STORAGE, false);
        return data?.[keys.mealsData] || null;
    },
    setMealsData: (mealsData) => {
        storageService.update(STORAGE_KEYS.KITCHEN_MEALS_STORAGE, { [keys.mealsData]: mealsData });
    },
    getSelectedMealId: () => {
        const data = storageService.get(STORAGE_KEYS.KITCHEN_MEALS_STORAGE, false);
        return data?.[keys.selectedMealId] ?? null;
    },
    setSelectedMealId: (id) => {
        storageService.update(STORAGE_KEYS.KITCHEN_MEALS_STORAGE, { [keys.selectedMealId]: id });
    },
    getSelectedDate: () => {
        const data = storageService.get(STORAGE_KEYS.KITCHEN_MEALS_STORAGE, false);
        return data?.[keys.selectedDate] || null;
    },
    setSelectedDate: (date) => {
        storageService.update(STORAGE_KEYS.KITCHEN_MEALS_STORAGE, { [keys.selectedDate]: date });
    },
    getSelectedDetailItem: () => {
        const data = storageService.get(STORAGE_KEYS.KITCHEN_MEALS_STORAGE, false);
        return data?.[keys.selectedDetailItem] ?? null;
    },
    setSelectedDetailItem: (item) => {
        storageService.update(STORAGE_KEYS.KITCHEN_MEALS_STORAGE, { [keys.selectedDetailItem]: item });
    },
    getSelectedDetailType: () => {
        const data = storageService.get(STORAGE_KEYS.KITCHEN_MEALS_STORAGE, false);
        return data?.[keys.selectedDetailType] ?? 'meal';
    },
    setSelectedDetailType: (type) => {
        storageService.update(STORAGE_KEYS.KITCHEN_MEALS_STORAGE, { [keys.selectedDetailType]: type });
    },
    getActiveTab: () => {
        const data = storageService.get(STORAGE_KEYS.KITCHEN_MEALS_STORAGE, false);
        return data?.[keys.activeTab] ?? 0;
    },
    setActiveTab: (tab) => {
        storageService.update(STORAGE_KEYS.KITCHEN_MEALS_STORAGE, { [keys.activeTab]: tab });
    },
    getSelectedKitchenId: () => {
        const data = storageService.get(STORAGE_KEYS.KITCHEN_MEALS_STORAGE, false);
        return data?.[keys.selectedKitchenId] ?? null;
    },
    setSelectedKitchenId: (id) => {
        storageService.update(STORAGE_KEYS.KITCHEN_MEALS_STORAGE, { [keys.selectedKitchenId]: id });
    },
    getScannedKitchenId: () => {
        const data = storageService.get(STORAGE_KEYS.KITCHEN_MEALS_STORAGE, false);
        return data?.[keys.scannedKitchenId] ?? null;
    },
    setScannedKitchenId: (id) => {
        storageService.update(STORAGE_KEYS.KITCHEN_MEALS_STORAGE, { [keys.scannedKitchenId]: id });
    },
};
